/* ============================================================
   OBEYTHECULTURE  COLLECTIONS INDEX  GSAP Animations
   ============================================================ */
(() => {
  'use strict';

  const gsap = window.gsap;
  const ScrollTrigger = window.ScrollTrigger;
  if (!gsap || !ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  /*  Hero entrance  */
  const heroBg = document.querySelector('.coll-hero-bg');
  const heroContent = document.querySelector('.coll-hero-content');

  if (heroBg) {
    gsap.fromTo(heroBg, { scale: 1.08 }, { scale: 1, duration: 2.5, ease: 'power4.out', delay: 0.2 });
  }
  if (heroContent) {
    gsap.fromTo(heroContent.children,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 1.2, stagger: 0.15, ease: 'power3.out', delay: 0.5 }
    );
  }

  /*  Hero parallax  */
  if (heroBg) {
    gsap.to(heroBg, {
      yPercent: 12,
      ease: 'none',
      scrollTrigger: {
        trigger: '.coll-hero',
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
    });
  }

  /*  Panel stagger reveals  */
  gsap.utils.toArray('.coll-panel').forEach((panel, i) => {
    const media = panel.querySelector('.coll-panel-media');
    const body = panel.querySelector('.coll-panel-body');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: panel,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
    });

    // Reveal panel
    tl.to(panel, {
      opacity: 1,
      y: 0,
      duration: 0.9,
      ease: 'power3.out',
    });

    // Image slide-in
    if (media) {
      tl.fromTo(media,
        { clipPath: 'inset(0 0 100% 0)' },
        { clipPath: 'inset(0 0 0% 0)', duration: 1, ease: 'power3.inOut' },
        '-=0.6'
      );
    }

    // Text fade-in
    if (body) {
      tl.fromTo(body.children,
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.8, stagger: 0.1, ease: 'power3.out' },
        '-=0.6'
      );
    }
  });

  /*  Image parallax on scroll  */
  gsap.utils.toArray('.coll-panel-media img').forEach(img => {
    gsap.fromTo(img,
      { yPercent: -5 },
      {
        yPercent: 5,
        ease: 'none',
        scrollTrigger: {
          trigger: img.closest('.coll-panel'),
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1.5,
        },
      }
    );
  });

})();
